export interface ApiErrorBody {
  error: {
    code: string;
    params?: Record<string, unknown>;
    details?: Record<string, string>;
  };
  requestId: string;
}

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly params?: Record<string, unknown>;

  constructor(status: number, body?: Partial<ApiErrorBody>) {
    super(body?.error?.code ?? 'NETWORK_ERROR');
    this.name = 'ApiError';
    this.status = status;
    this.code = body?.error?.code ?? 'NETWORK_ERROR';
    this.params = body?.error?.params;
  }
}

export const isApiError = (error: unknown): error is ApiError => error instanceof ApiError;
